import styled from "@emotion/styled";
import { Countdown, Text } from "atoms";
import { getOpenCallTag } from "../utils/getOpenCallTag";
import type { OpenCall } from "../types";

type OpenCallDateProps = {
  openCall: OpenCall;
  isFeatured?: boolean;
};

function OpenCallCardDate({ openCall, isFeatured }: OpenCallDateProps) {
  const tag = getOpenCallTag(openCall);
  const {
    submissionStartDate,
    submissionEndDate,
    communityVotingStartDate,
    communityVotingEndDate,
  } = openCall;

  if (
    ["Artists Selected", "Concluded", "On Display", "Under Curation"].includes(
      tag,
    )
  ) {
    return null;
  }

  if (tag === "Submissions Open" && !submissionEndDate) {
    return (
      <CardDate>
        <strong>Ongoing</strong>
      </CardDate>
    );
  }

  let endDate = null;
  let isEndDate;
  if (tag === "Coming Soon") {
    endDate = new Date(submissionStartDate ?? "");
  }
  if (tag === "Submissions Open") {
    endDate = new Date(submissionEndDate ?? "");
    isEndDate = true;
  }
  if (tag === "Voting Soon") {
    endDate = new Date(communityVotingStartDate ?? "");
  }
  if (tag === "Voting Open") {
    endDate = new Date(communityVotingEndDate ?? "");
    isEndDate = true;
  }
  if (endDate === null) {
    return null;
  }

  const prefix = tag.includes("Open") ? "Closes" : "Opens";

  return (
    <CardDate textAlign={isFeatured ? "left" : "center"}>
      <Countdown
        date={endDate}
        showSeconds={isFeatured}
        textBefore={prefix}
        isEndDate={isEndDate}
      />
    </CardDate>
  );
}

const CardDate = styled(Text)(({ theme }) => ({
  color: theme.colors.bodyColor,
  margin: 0,
  width: "100%",
  maxWidth: "max-content",
  fontSize: 13,
  textAlign: "right",
  lineHeight: 1.2,
  "&&": { flex: 1 },
  "&,*": {
    fontWeight: "bold",
    margin: 0,
  },
})).withComponent("div");

export { OpenCallCardDate };
